import { type ReactElement } from 'react'
import { type MaterialSymbolType } from '@front/model'
import { MaterialSymbolIcon } from '@components'

type ResultTypeIconProps = {
  icon: MaterialSymbolType
}

export const ResultTypeIcon = ({ icon }: ResultTypeIconProps): ReactElement => {
  return (
    <div className='bg-default-hover flex items-center justify-center rounded-md p-1'>
      <MaterialSymbolIcon icon={icon} size={20} className='text-dimmed' />
    </div>
  )
}
